import { render, staticRenderFns } from "./CreateSalesOrderModal.vue?vue&type=template&id=f3f672da&scoped=true&"
import script from "./CreateSalesOrderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateSalesOrderModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSalesOrderModal.vue?vue&type=style&index=0&id=f3f672da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f672da",
  null
  
)

export default component.exports